import { Tag, Typography } from 'antd';
import { LockOutlined, CheckCircleTwoTone, StopOutlined } from '@ant-design/icons';

const { Text } = Typography;

export function buildBrandColumns({ currentPage, pageSize } = {}) {
  return [
    {
      title: '#', key: '__sno__', width: 56, align: 'center', fixed: 'left',
      render: (_v, _r, idx) => {
        const cp = Number(currentPage) > 0 ? Number(currentPage) : 1;
        const ps = Number(pageSize)    > 0 ? Number(pageSize)    : 25;
        return <span className="erp-grid__muted">{(cp - 1) * ps + idx + 1}</span>;
      }
    },
    {
      title: 'Code', key: 'brandCode', dataIndex: 'brandCode',
      sortField: 'brand_code', sorter: true,
      width: 140, fixed: 'left', dataType: 'string',
      render: (v) => v
        ? <code className="erp-grid__code">{v}</code>
        : <span className="erp-grid__muted">—</span>
    },
    {
      title: 'Name', key: 'brandName', dataIndex: 'brandName',
      sortField: 'brand_name', sorter: true,
      width: 220, ellipsis: true, dataType: 'string',
      render: (v) => <span className="erp-grid__primary">{v}</span>
    },
    {
      title: 'Display Name', key: 'displayName', dataIndex: 'displayName',
      sortField: 'display_name',
      width: 200, ellipsis: true, dataType: 'string',
      render: (v) => v ? <span>{v}</span> : <Text type="secondary">—</Text>
    },
    {
      title: 'Country', key: 'countryCode', dataIndex: 'countryCode',
      sortField: 'country_code',
      width: 100, align: 'center', dataType: 'string',
      render: (v) => v ? <Tag className="erp-grid__tag">{v}</Tag> : <Text type="secondary">—</Text>
    },
    {
      title: 'Website', key: 'websiteUrl', dataIndex: 'websiteUrl',
      width: 220, ellipsis: true, dataType: 'string',
      render: (v) => v
        ? <a href={/^https?:\/\//i.test(v) ? v : `https://${v}`}
             target="_blank" rel="noreferrer"
             onClick={(e) => e.stopPropagation()}>{v}</a>
        : <Text type="secondary">—</Text>
    },
    {
      title: 'System', key: 'isSystem', dataIndex: 'isSystem',
      sortField: 'is_system', filterField: 'is_system',
      width: 100, align: 'center', dataType: 'boolean',
      filters: [{ text: 'System', value: 'true' }, { text: 'User', value: 'false' }],
      render: (v) => v
        ? <Tag icon={<LockOutlined />} color="default" className="erp-grid__tag">System</Tag>
        : <span className="erp-grid__muted">User</span>
    },
    {
      title: 'Status', key: 'isActive', dataIndex: 'isActive',
      sortField: 'is_active', filterField: 'is_active',
      width: 110, align: 'center', dataType: 'boolean',
      filters: [{ text: 'Active', value: 'true' }, { text: 'Inactive', value: 'false' }],
      render: (v) => v
        ? <Tag icon={<CheckCircleTwoTone twoToneColor="#52c41a" />} color="success" className="erp-grid__tag">Active</Tag>
        : <Tag icon={<StopOutlined />} color="default" className="erp-grid__tag">Inactive</Tag>
    }
  ];
}
